import { memo } from 'react';
import style from './Spinner.module.css';
import type { Props } from './Spinner.types';

export const Spinner = memo<Props>(({ size = 'm' }) => (
  <div className={style[size]} />
));

export const SpinnerContent = memo(() => <Spinner />);
